<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AuP26a/images/9781523001910.jpg?1736120154645" alt="This image is the cover for the book Confessions of an Economic Hit Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confessions of an Economic Hit Man
      </h1>
      <p class="bookDescription body article font2">
        <p>Los Angeles Times Bestseller How do we stop the unrelenting evolution of the economic hit man strategy and China's takeover? The riveting third edition of this New York Times bestseller blows the whistle on China's economic hit man (EHM) strategy, exposes corruption on an international scale, and offers much-needed solutions for curing the degenerative Death Economy. In this shocking expos, former EHM John Perkins gives an insider view into the corrupt system that cheats and strong-arms countries around the globe out of trillions of dollars and ultimately causes staggering income inequality and ecological devastation. EHMs are highly paid professionals who use development loans to saddle countries with huge debts and force them to serve US interests. Now, a new EHM wave is infecting the world, and at the peak of the devastation sits China, a newly dominant economic power, with its own insidious version of the US EHM blueprint. Twelve explosive new chapters detail the allure, exploitation, and wreckage of China's EHM strategy in Latin America, Asia, Africa, the Middle East, and Europe. If allowed to continue its rampage, the EHM strategy-whether executed by the United States or China-will destroy life as we know it. However, all is not lost. Perkins offers a plan for transforming this system that places profits above all into a Life Economy that restores the earth. He inspires readers to take actions toward a new era of global cooperation that will end the United States's and China's EHM strategies for good.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Perkins
      </h2>
      
      <p class="authorDescription body article">John Perkins has written eleven books, including the first edition of this book, which was on the New York Times bestseller list for more than seventy weeks and was translated into over thirty languages. As a former chief economist, he advised the World Bank, the United Nations, Fortune 500 corporations, and governments around the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c5d94c8